import React, { Component } from 'react';
import ToggleLeaderboardButton from '../leaderboard/ToggleLeaderboardButton';


class Home extends Component {
  constructor() {
    super();

    this.state = {
      videoCanPlay: false,
    };

    this.imageAnimationRef = React.createRef();
  }

  render() {
    return (
      <div className="thunderbolt__page home">
        <div className="video-container">
          <div className="video-overlay"></div>
          <video className={`${this.state.videoCanPlay === true ? 'loaded' : ''}`} autoPlay loop muted playsInline onCanPlay={() => this.setState({ videoCanPlay: true })}>
            <source src={this.props.page.content.contentFields.videoBackground} type="video/mp4"></source>
          </video>
        </div>

        <div className="content-block">
          <img className="logo" src={this.props.page.content.contentFields.logo}/>

          <h1>{this.props.page.content.contentFields.mainHeading}</h1>

          <div className="content-container" dangerouslySetInnerHTML={{ __html: this.props.page.content.contentFields.introText }}></div>

          <ToggleLeaderboardButton size="large"></ToggleLeaderboardButton>
        </div>
      </div>
    );
  }
}

export default Home;
